import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoggedInNavComponent } from 'src/app/components/ui/logged-in-nav/logged-in-nav.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LazyImageComponent } from 'src/app/components/lazy-image/lazy-image.component';
import { AddressFormatterPipe } from 'src/app/address-formatter.pipe';

import { MatMenuModule } from '@angular/material/menu';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { CreateHorseComponent } from 'src/app/components/create-horse/create-horse.component';
import { HumanizeStatusPipe } from 'src/app/pipes/humanize-status.pipe';
import { DaysAgoPipe } from 'src/app/pipes/days-ago.pipe';
import { CustomerSearchComponent } from 'src/app/components/customer-search/customer-search.component';
import { AppointmentSummaryComponent } from 'src/app/components/appointment-summary/appointment-summary.component';




@NgModule({
  declarations: [
    LoggedInNavComponent,
    AddressFormatterPipe,
    HumanizeStatusPipe,
    DaysAgoPipe,
    AppointmentSummaryComponent,
    
    
    
    
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    MatMenuModule,
    FontAwesomeModule,
    CustomerSearchComponent,
    DatePipe
    
    
    
   
  ],
  providers:[
    LazyImageComponent, 
    AddressFormatterPipe,
    DatePipe
    
    
  ],
  exports: [
    LoggedInNavComponent,
    FontAwesomeModule,
    AddressFormatterPipe,
    HumanizeStatusPipe,
    DaysAgoPipe,
    CustomerSearchComponent,
    AppointmentSummaryComponent
    
    
  ]
})
export class SharedUIModuleModule { }
